import { LocalStorage } from './storage';

export const signOut = () => {
  LocalStorage.clearAll();
  const url = '/';
  window.location.replace(url);
};
